import { render, staticRenderFns } from "./AccSetupPaymentMethod.vue?vue&type=template&id=2fe0502a&scoped=true"
import script from "./AccSetupPaymentMethod.vue?vue&type=script&lang=js"
export * from "./AccSetupPaymentMethod.vue?vue&type=script&lang=js"
import style0 from "./AccSetupPaymentMethod.vue?vue&type=style&index=0&id=2fe0502a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fe0502a",
  null
  
)

export default component.exports